import { useLayout } from './LayoutManager'
import project from '@client/stores/projectStore'

export type BreadCrumbProps = { config: { id: string }; breadCrumb?: string | string[]; absolute?: boolean }
export default function BreadCrumb({ config, breadCrumb = '', absolute = false }: BreadCrumbProps) {
    const { cmd } = useLayout()

    let items = []
    const showBreadCrumb = cmd('showBreadCrumb', { activeKey: config.id, tab: config })
    if (showBreadCrumb) {
        const useProjectName = cmd('useProjectInBreadCrumb', { activeKey: config.id, tab: config })
        items = cmd('getBreadCrumb', { activeKey: config.id, tab: config })
        if (useProjectName && project.currentProject.value?.name) items?.unshift(project.currentProject.value?.name)
        if (breadCrumb) {
            if (absolute) items = []
            if (typeof breadCrumb == 'string') items.push(breadCrumb)
            else if (Array.isArray(breadCrumb))
                breadCrumb.forEach((item) => {
                    items.push(item)
                })
        }
    }

    return (
        <div className="breadcrumb">
            {items?.map((item: string, index: number) => {
                let text = ''
                if (index > 0) text += ' > '
                return text + item
            })}
        </div>
    )
}
